import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-datepicker', 'selectDate', 'Vali kuupäev');
Labels.set('ui-datepicker', 'selectedDate', 'Valitud kuupäev');
Labels.set('ui-datepicker', 'close', 'Kinni');
Labels.set('ui-datepicker', 'clear', 'Puhasta väli');
Labels.set(
    'ui-datepicker',
    'invalidFormatHint',
    'Kasuta kuupäevavormingut pp.kk.aaaa, näiteks 24.12.2026.'
);
